import React from 'react';
import { Link } from 'react-router-dom';

const BlogPreview = () => {
  const blogPosts = [
    {
      title: 'Understanding Early Signs of Oral Cancer',
      author: 'Dr. Adesh Palyekar',
      readingTime: '4 min read',
      description: 'Oral cancer is often detected late, but early signs can make a big difference. Learn about the symptoms, risk factors, and when to consult a specialist for prompt diagnosis and treatment.',
      slug: 'oral-cancer-signs'
    },
    {
      title: 'How to Lower Your Risk of Cancer: Lifestyle Tips',
      author: 'Dr. Adesh Palyekar',
      readingTime: '5 min read',
      description: 'While not all cancers are preventable, healthy lifestyle choices can significantly reduce your risk. Discover evidence-based tips for diet, exercise, and regular screenings.',
      slug: 'lower-cancer-risk'
    },
    {
      title: 'What to Expect During Cancer Surgery',
      author: 'Dr. Adesh Palyekar',
      readingTime: '6 min read',
      description: 'Cancer surgery can be daunting. This guide explains the process, from pre-surgery preparation to recovery, so you know what to expect and how to plan for the best outcome.',
      slug: 'cancer-surgery-expect'
    }
  ];

  return (
    <section id="blog" className="section bg-white">
      <div className="container">
        <h2 className="section-title">Blog & Cancer Insights</h2>
        
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {blogPosts.map((post, index) => (
            <article key={index} className="card p-6 group" itemScope itemType="https://schema.org/BlogPosting">
              <h3 className="font-montserrat text-xl font-bold text-primary-500 mb-3 group-hover:text-accent-500 transition-colors duration-300" itemProp="headline">
                <Link to={`/blog/${post.slug}`} className="hover:underline">
                  {post.title}
                </Link>
              </h3>
              
              <div className="flex items-center gap-2 text-sm text-text-muted mb-4">
                <span className="font-montserrat font-semibold" itemProp="author">{post.author}</span>
                <span>•</span>
                <span>{post.readingTime}</span>
              </div>
              
              <p className="text-text-muted mb-4 leading-relaxed" itemProp="description">
                {post.description}
              </p>
              
              <Link 
                to={`/blog/${post.slug}`} 
                className="text-accent-500 font-montserrat font-semibold hover:text-accent-600 transition-colors duration-300 inline-flex items-center gap-2 group-hover:gap-3" 
                itemProp="url"
              >
                Read more
                <i className="fa fa-arrow-right text-sm"></i>
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogPreview; 